import { Stack, Typography } from "@mui/material";
import { SettingsIcon } from "../../images";
import { CustomButton } from "../../ui/CustomButton";
import { ManageSectionsBtn } from "../../ui/buttons";

export const CustomizeDocumentationBlock = ({
  isEditor,
  campaign_id,
}: {
  isEditor?: boolean;
  campaign_id: string;
}) => {
  if (!isEditor) return null;

  return (
    <Stack
      sx={{
        width: "100%",
        padding: "24px 16px",
        gap: "16px",
        borderRadius: "6px",
        boxShadow: "0 4px 15.8px 0 #0000001A",
      }}
    >
      <Stack gap={"24px"}>
        <Stack gap={"8px"}>
          <Typography
            color="custom.textDarkBlue"
            variant="subtitle1"
            sx={{
              fontWeight: "600",
            }}
          >
            Customize Documentation
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Define sections to be present in the generated documentation on the
            campaign level.
          </Typography>
        </Stack>
        <ManageSectionsBtn
          campaign_id={campaign_id}
          customButton={(onClick) => (
            <CustomButton
              onClick={onClick}
              variant="outlined"
              customColor="#FFFFFF"
              textColor="#1D3E70"
              type="button"
              fullWidth
              sx={{
                borderColor: "#1D3E70",
                backgroundColor: "transparent",
              }}
              startIcon={<SettingsIcon />}
            >
              Manage Sections
            </CustomButton>
          )}
        />
      </Stack>
    </Stack>
  );
};
